<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment_group')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                  v-on:keyup.enter="onSearch"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success"
                  @click="onSearch"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartmentGroup.title") }}</b>
              <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_apartment_group')"
                @click="addNew($event)"
                >{{ $t("common.addnew") }}</lte-button
              >
            </div>
          </div>
          <div class="box-body">
            <!-- B-Table Start -->
            <b-table
              :items="gridDataList"
              :fields="gridColumns"
              class="mt-3"
              outlined
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 50px">
                    <li>
                      <button
                        v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('update_apartment_group')"
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditInput(row.item)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                    </li>
                    <li style="margin-top: 5px">
                      <button
                        v-if="GET_ACCOUNT_DATA.id == 1 ||  has_perm('update_apartment_group')"
                        class="btn btn-info btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenApartmentInGroupList(row.item)"
                      >
                        <i class="glyphicon glyphicon-home"></i>
                      </button>
                    </li>
                    <li style="margin-top: 5px">
                      <button
                        v-if="GET_ACCOUNT_DATA.id == 1 ||  has_perm('delete_apartment_group')"
                        class="btn btn-danger btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenDelete(row.item)"
                      >
                        <i class="glyphicon glyphicon-trash"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
            <!-- B-Table End -->
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
      </row>
    </div>
    <!-- /.modal -->
    <div
      class="modal fade"
      :ref="`modal-apartment-group`"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              {{
                $t(
                  apartmentGroupData.id === 0
                    ? "apartmentGroup.apartmentGroupAdd"
                    : "apartmentGroup.apartmentGroupDetail"
                )
              }}
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label required" for="">{{
                    $t("apartmentGroup.apartmentGroupName")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="apartmentGroupData.apartmentGroupName"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">{{ $t("apartmentGroup.description") }}</label>
                  <textarea
                    class="form-control"
                    name=""
                    id=""
                    cols="30"
                    rows="4"
                    v-model="apartmentGroupData.description"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              style="background-color: #f29911;border-color: #f29911;color:#fff"
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >
              {{ $t("common.back") }}
            </button>
            <button type="button" class="btn btn-primary" @click="onSave">
              {{ $t("common.save") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <apartment-in-group-list ref="apartmentInGroupList" />
    <!--  -->
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapGetters, mapActions } from "vuex";
import LTEButton from "@/components/LTEButton.vue";
import LTEModal from "@/components/LTEModal.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import ApartmentInGroupList from "./ApartmentInGroupList"
import utils from '@/lib/utils';
// import moment from "moment";
import Loading from "vue-loading-overlay";

export default {
  data() {
    return {
      gridDataList: [],
      gridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          sortable: true,
          class: "text-center "
        },
        {
          label: "apartmentGroup.apartmentGroupName",
          key: "apartmentGroupName",
          sortable: true,
          class: "text-center "
        },
        {
          label: "apartmentGroup.description",
          key: "description",
          sortable: true,
          class: "text-center "
        },
        { key: "actions", label: "common.action", sortable: false }
      ],
      originalRecordData: [],
      isModalVisible: false,
      objModal: [
        {
          title: "common.delete_modal.title",
          body: "common.delete_modal.content",
          buttonNo: "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
      search: {
        searchText: ""
      },
      isLoading: false,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      apartmentGroupData: {
        id: 0,
        apartmentGroupName: null,
        description: null
      },
    };
  },
  watch: {
    GET_LANG: function() {
      this.getApartmentTypeList(1);
    },
    GET_APARTMENT_GROUP_LIST_DATA: function() {
      let paginate = this.GET_APARTMENT_GROUP_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_APARTMENT_GROUP_LIST_DATA.results;
      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;

        let data = {
          id: id,
          nonumber: nonumber,
          apartmentGroupName: element.name,
          description: element.description
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_GROUP_LIST_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getSearchData: function(data){
      this.search.searchText = data
      this.getApartmentTypeList(1);
    },
    onSearch: function() {
      this.getApartmentTypeList(1);
    },
    addNew: function() {
      $(this.$refs[`modal-apartment-group`]).modal("show");
      this.apartmentGroupData = {
        id: 0,
        apartmentGroupName: null,
        description: null,
      };
    },
    onOpenEditInput: function(row) {
      $(this.$refs[`modal-apartment-group`]).modal("show");
      this.apartmentGroupData = {
        id: row.id,
        apartmentGroupName: row.apartmentGroupName,
        description: row.description
      };
    },

    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_APARTMENT_GROUP(this.originalRecordData)
        .then(
          function() {
            this.getApartmentTypeList(this.paginateData.currentPage);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPagination: function(data) {
      this.getApartmentTypeList(data.params.page)
    },
    closeModal() {
      this.isModalVisible = false;
    },

    onOpenDelete: function(row) {
      this.originalRecordData = row;
      this.isModalVisible = true;
    },
    getApartmentTypeList: function(page) {
      this.isLoading = true;
      let filter = {
        params: {
          page: page,
          searchText: this.search.searchText
        }
      };
      this.GET_APARTMENT_GROUP_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onGetData: function(){
      this.getApartmentTypeList(this.paginateData.currentPage)
    },
    validateData: function() {
      let validatedResult = "OK";
      for (let key in this.apartmentGroupData) {
        if (key === "description") {
          //
        } else if (utils.isEmptyString(this.apartmentGroupData[key])) {
          validatedResult = this.$t("apartmentGroup." + key);
          break;
        }
      }
      return validatedResult;
    },
    onSave: function() {
      let results = this.validateData();
      if (results === "OK") {
        let data = {
          id: this.apartmentGroupData.id,
          name: this.apartmentGroupData.apartmentGroupName,
          description: this.apartmentGroupData.description
        };
        if (this.apartmentGroupData.id === 0) {
          this.CREATE_APARTMENT_GROUP(data).then(
            function() {
              $(this.$refs[`modal-apartment-group`]).modal("hide");
              this.getApartmentTypeList(this.paginateData.currentPage);
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              this.ON_SHOW_TOAST();
            }.bind(this)
          );
        } else {
          this.UPDATE_APARTMENT_GROUP(data).then(
            function() {
              $(this.$refs[`modal-apartment-group`]).modal("hide");
              this.getApartmentTypeList(this.paginateData.currentPage);
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.isLoading = false;
              this.ON_SHOW_TOAST();
            }.bind(this)
          );
        }
      } else {
        this.ON_SHOW_TOAST({
          message: results,
          styleType: "danger"
        });
      }
    },
    onOpenApartmentInGroupList: function(data) {
      this.$refs.apartmentInGroupList.getApartmentInGroup(data.id)
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "DELETE_APARTMENT_GROUP",
      "GET_APARTMENT_GROUP_LIST",
      "CREATE_APARTMENT_GROUP",
      "UPDATE_APARTMENT_GROUP"
    ])
  },
  mounted() {
    this.getApartmentTypeList(1);
  },

  components: {
    "lte-button": LTEButton,
    "lte-modal": LTEModal,
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading,
    ApartmentInGroupList
  }
};
</script>
<style scoped>

label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/views/ApartmentGroup/ApartmentGroupList.vue